import Vue from 'vue';
import i18n from "../../../i18n";

export default {
  
  async createUserInRole({  commit }, payload) {
    return Vue.axios
      .post(Vue.$url("user-role"), payload)
      .then((rsp) => {
        Vue.$log.debug("created and saved under", rsp.data.id);
        commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Role', 1: payload.description }), {root : true});
      })
  },

  async fetchUserInRoles({ commit }) {
    return Vue.axios.get(Vue.$url("user-role"))
      .then((rsp) => commit('SET_USERINROLES', rsp.data))
  },

  async updateUserInRole({ commit }, payload) {
    return Vue.axios
      .put(Vue.$url("user-role" + payload.id), payload)
      .then(() => {
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Role', 1: payload.description }), {root: true});
      });
  },

}